import React from "react";
import { useSelector } from "react-redux";

import { MeasureSketch } from "../MeasureSketch/MeasureSketch";

import { getOffsets } from "../../helpers/dimensions";

import { SketchContainer, UterumImageContainer, UterumImage } from "./style";

export const MeasureSketches = () => {
  const { assetBaseUrl, alias } = useSelector((state) => state.init);
  const Result = useSelector((state) => state.Result);
  const Uterum = useSelector((state) => state.Uterum);

  const { ImagesRight, ImagesLeft, UterumHeights, Roof } = Result;
  const imageFolder = useSelector((state) => state.Uterum.ImageFolder);
  const offsetsObj = getOffsets(
    Uterum.FrameAreas,
    Uterum.Corners,
    Uterum.FrameType
  );

  return (
    <SketchContainer>
      {ImagesRight.Images && ImagesLeft.Images && (
        <>
          <UterumImageContainer>
            {ImagesRight.Images.map((image, index) => (
              <UterumImage
                key={index}
                src={`${assetBaseUrl}/store/uterumsguide2016/${image.ImageFolder}/ANGLE_RIGHT/${image.Area}/${image.Img}.png`}
              />
            ))}
          </UterumImageContainer>
          <UterumImageContainer>
            {ImagesLeft.Images.map((image, index) => (
              <UterumImage
                key={index}
                src={`${assetBaseUrl}/store/uterumsguide2016/${image.ImageFolder}/ANGLE_LEFT/${image.Area}/${image.Img}.png`}
              />
            ))}
          </UterumImageContainer>
        </>
      )}
      {Uterum.FrameType ? (
        <>
          {Uterum.FrameType === "FIRAVINKEL" ? (
            <>
              <MeasureSketch
                headLine={alias.bfcOuterMeasure}
                imageUrl={`${assetBaseUrl}/store/Bfc_1.5/outer/outer_w${Uterum.FrameWidth}_d${Uterum.FrameDepth}_a${Uterum.FrameAddonWidth}.png`}
              />
              <MeasureSketch
                headLine={alias.bfcInnerMeasure}
                imageUrl={`${assetBaseUrl}/store/Bfc_1.5/inner/inner_w${Uterum.FrameWidth}_d${Uterum.FrameDepth}_a${Uterum.FrameAddonWidth}.png`}
              />
              <MeasureSketch
                headLine={alias.bfcRoofMeasure}
                imageUrl={`${assetBaseUrl}/store/Bfc_1.5/roof/roof_w${Uterum.FrameWidth}_d${Uterum.FrameDepth}_a${Uterum.FrameAddonWidth}.png`}
              />
              <MeasureSketch
                headLine={alias.bfcHeightMeasure}
                imageUrl={`${assetBaseUrl}/store/Bfc_1.5/height/height_w${Uterum.FrameWidth}_d${Uterum.FrameDepth}_a${Uterum.FrameAddonWidth}.png`}
              />
            </>
          ) : (
            <>
              <MeasureSketch
                imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/inner.png`}
                topText={
                  offsetsObj.BACK ? (
                    `${offsetsObj.BACK} mm`
                  ) : offsetsObj.BACKSIDE_LEFT ? (
                    <>
                      <span className="measure">{`${offsetsObj.BACKSIDE_LEFT} mm`}</span>
                      <span className="measure">{`${offsetsObj.BACKSIDE_RIGHT} mm`}</span>
                    </>
                  ) : (
                    ""
                  )
                }
                centerText={alias.bfcInnerStommeDimension}
                leftText={
                  offsetsObj.ONSIDE_LEFT_BACK ? (
                    <>
                      <span className="measure">{`${offsetsObj.ONSIDE_LEFT} mm`}</span>
                      <span className="measure">{`${offsetsObj.ONSIDE_LEFT_BACK} mm`}</span>
                    </>
                  ) : offsetsObj.ONSIDE_LEFT ? (
                    `${offsetsObj.ONSIDE_LEFT} mm`
                  ) : (
                    ""
                  )
                }
                bottomText={
                  offsetsObj.FRONT ? (
                    `${offsetsObj.FRONT} mm`
                  ) : offsetsObj.FRONT_LEFT ? (
                    <>
                      <span className="measure">{`${offsetsObj.FRONT_LEFT} mm`}</span>
                      <span className="measure">{`${offsetsObj.FRONT_RIGHT} mm`}</span>
                    </>
                  ) : (
                    ""
                  )
                }
                rightText={
                  offsetsObj.ONSIDE_RIGHT_BACK ? (
                    <>
                      <span className="measure">{`${offsetsObj.ONSIDE_RIGHT_BACK} mm`}</span>
                      <span className="measure">{`${offsetsObj.ONSIDE_RIGHT} mm`}</span>
                    </>
                  ) : offsetsObj.ONSIDE_RIGHT ? (
                    `${offsetsObj.ONSIDE_RIGHT} mm`
                  ) : (
                    ""
                  )
                }
              />
              <MeasureSketch
                imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/outer.png`}
                rightText={`${Uterum.FrameDepth} mm`}
                centerText={alias.bfcOuterStommeDimension}
                leftText={`${Uterum.FrameDepth} mm`}
                bottomText={`${Uterum.FrameWidth} mm`}
              />
              <MeasureSketch
                imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/roofmodel.png`}
                overlayImageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/roof.png`}
                leftText={`${Roof.RoofDepth} mm`}
                centerText={alias.bfcOuterRoofDimension}
                rightText={`${Roof.RoofDepth} mm`}
                bottomText={`${Roof.RoofWidth} mm`}
              />
              <MeasureSketch
                imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/height.png`}
                leftText={`${UterumHeights.HeightRoofTop} mm`}
                centerText={alias.bfcHeightStommeRoof}
                rightText={`${UterumHeights.HeightRoofLower} mm`}
                frameType={Uterum.FrameType}
              />
            </>
          )}
        </>
      ) : (
        <>
          <MeasureSketch
            imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/inner.png`}
            topText={
              offsetsObj.BACK
                ? `${offsetsObj.BACK} mm`
                : offsetsObj.BACKSIDE_LEFT
                  ? `${offsetsObj.BACKSIDE_LEFT} mm ${offsetsObj.BACKSIDE_RIGHT} mm`
                  : ""
            }
            centerText={alias.bfcInnerMeasure}
            leftText={
              offsetsObj.ONSIDE_LEFT
                ? `${offsetsObj.ONSIDE_LEFT} mm`
                : `${offsetsObj.ONSIDE_LEFT_BACK} mm ${offsetsObj.ONSIDE_LEFT_BACK} mm`
            }
            bottomText={
              offsetsObj.FRONT
                ? `${offsetsObj.FRONT} mm`
                : `${offsetsObj.FRONT_LEFT} mm ${offsetsObj.FRONT_RIGHT} mm`
            }
            rightText={
              offsetsObj.ONSIDE_RIGHT_BACK
                ? `${offsetsObj.ONSIDE_RIGHT} mm ${offsetsObj.ONSIDE_RIGHT_BACK} mm`
                : `${offsetsObj.ONSIDE_RIGHT} mm`
            }
          />
          <MeasureSketch
            imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/outer.png`}
            rightText={`${Uterum.FrameDepth} mm`}
            centerText={alias.bfcOuterStommeDimension}
            leftText={`${Uterum.FrameDepth} mm`}
            bottomText={`${Uterum.FrameWidth} mm`}
          />
          <MeasureSketch
            imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/roofmodel.png`}
            leftText={`${Roof.RoofDepth} mm`}
            centerText={alias.bfcOuterRoofDimension}
            rightText={`${Roof.RoofDepth} mm`}
            bottomText={`${Roof.RoofWidth} mm`}
          />
          <MeasureSketch
            imageUrl={`${assetBaseUrl}/store/uterumsguide2016/${imageFolder}/measurement/height.png`}
            leftText={`${UterumHeights.HeightRoofTop} mm`}
            centerText={alias.bfcRoofHeight}
            rightText={`${UterumHeights.HeightRoofLower} mm`}
          />
        </>
      )}
    </SketchContainer>
  );
};
